/* 
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

module.exports = Rect
/**
 * Classe utilisée de façon interne pour représenter un rectangle.
 * @constructor
 * @param {Float} x : L'abscisse du bord supérieur gauche.
 * @param {Float} y : L'ordonnée du bord supérieur gauche.
 * @param {Float} width : La largeur du rectangle.
 * @param {type} height : La hauteur du rectangle.
 * @returns {Rect}
 */
function Rect (x,y,width,height) {
  this.x = x;
  this.y = y;
  this.width = width;
  this.height = height;
}
/*
Rect.prototype.setRec = function(rx,ry,rwidth,rheight) {
  if (arguments.length == 1) {
    this.x = rx.x;
    this.y = rx.y;
    this.width = rx.width;
    this.height = rx.height;
  }
  else {
    this.x = rx;
    this.y = ry;
    this.width = rwidth;
    this.height = rheight;
  }
};
*/
Rect.prototype.contains = function(xt,yt) {
  return (xt>=this.x) && (yt>=this.y) && (xt<=this.x+this.width) && (yt<=this.y+this.height);
};



// WEBPACK FOOTER //
// ./src/types/Rect.js